<template>
  <div class="nav-wrap">
    <div class="nav-top-title">
      <div class="nav-top-title-icon"  @touchend.prevent="handleNav()">
        <div class="nav-top-title-icon-cent" ></div>
        <span>导 &nbsp;&nbsp;  航</span>
      </div>
      <div class="nav-top-title-title"  @touchend.prevent="handleHerf('Home')" >
        弘扬·追忆抗战精神
      </div>
    </div>
    <div   :class="[navlist?'op2':'op1']"  class="nav-content-title-nav">
      <ul class="nav-navlist-nav">
        <li @touchend.prevent="handleHerf('Resistance')">
          <span>听总书记讲抗战</span>
          <div>
            <div></div>
          </div>
        </li>
        <li @touchend.prevent="handleHerf('Remember')">
          <span>铭记历史<br>致敬胜利</span>
          <div>
            <div></div>
          </div>
        </li>
        <li @touchend.prevent="handleHerf('Remembrance')">
          <span> 追忆 追思 追忆</span>
          <div>
            <div></div>
          </div>
        </li>
        <li @touchend.prevent="handleNewHerf()">
          <span> 缅怀英烈<br>守护有我</span>
          <div>
            <div></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    props:['swipertop'],
    data() {
      return {
        navlist: false
      }
    },
    methods: {
      handleNav() {
        this.navlist = !this.navlist
      },
      handleHerf(item) {
        let url = '/'+item
        this.$router.push({
          name: item,
        });
        document.location.reload()
      },
      handleNewHerf(){
        window.open('http://yinglie.chinamartyrs.gov.cn/903h5')
      }
    },
    watch:{
      // 当a的值发生改变时触发
      swipertop:function(val,oldVal){
        this.navlist = val
      }
    }

  }
</script>
<style lang="scss" scoped>
 .nav-wrap {
  .nav-top-title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 120px;
    background: #c8a56e;
    .nav-top-title-icon {
      padding-top: 10px;
      position: relative;
      z-index: 100;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 100%;
      .nav-top-title-icon-cent{
        width: 70px;
        height: 70px;
        background: url("../assets/img/yyd-nav-bai.png");
        background-size: 100% 100%;
        animation: zy 2.5s .15s linear infinite;
        -moz-animation: zy 2.5s .15s linear infinite; /* Firefox */
        -webkit-animation: zy 2.5s .15s linear infinite; /* Safari and Chrome */
        -o-animation: zy 2.5s .15s linear infinite; /* Opera */
      }
      span{
        display: block;
        width: 100%;
        text-align: center;
        color: white;
        font-size: 16px;
      }
    }
    .nav-top-title-title {
      position: relative;
      z-index: 100;
      width:650px ;
      height: 100%;
      padding-right: 120px;
      box-sizing: border-box;
      text-align: center;
      box-shadow: 0 0 0px rgba(0,0,0,0);
      line-height: 120px;
      font-size: 35px;
      letter-spacing:10px;
      color: white;
      font-weight: 700;
    }
  }
  .nav-content-title-nav {
    position: absolute;
    width: 100%;
    height: 100%;
    background:rgba(255,255,255,1);
    transition: 1s all;
    &.op1{
         left: 0;
         top: -1400px;
         opacity: 0;
         z-index: 0;
      }
    &.op2{
        left: 0;
        top: 120px;
        opacity: 1;
        z-index: 1000;
    }
    .nav-navlist-nav {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: absolute;
      left: 50%;
      top: 2%;
      width: 85%;
      height: 85%;
      transform: translateX(-50%);
      li {
          box-sizing: border-box;
          width: 48%;
          height: 48%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          background-color: #a67c52;
          span{
            text-align: center;
             padding-top: 30%;
             padding-bottom: 15%;
             font-size: 40px;
             height: 100px;
             line-height: 50px;
             color: white;
           }
          div{
            flex: 1;
            display: flex;
            align-items: top;
            justify-content: center;
            div{
              background: url("../assets/img/ydd-sltp.png");
              background-size: 50% 42%;
              background-position: center center;
              background-repeat: no-repeat;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/topnav.vue